<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onClickRowItem"
        >
            <template v-slot:[`item.action`]="{ item }">
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('edit', item)">
                    <icon
                        value="edit"
                        size="18px"/>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'IBeaconMessageTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory({
            itemMapFunc: function (item) {
                let defaultMessage
                let preferedMessage
                // eslint-disable-next-line
                item?.messages?.forEach(message => {
                    if (message.langCode === this.$constant.locale.DEFAULT_IBEACON_LOCALE) {
                        defaultMessage = message
                    }

                    if (message.langCode === this.$i18n.locale) {
                        preferedMessage = message
                    }
                })

                let effectiveDates
                if (item.effectiveStartDate && item.effectiveEndDate) {
                    effectiveDates = `${this.$util.getDDMMYYYYDateFormat(item.effectiveStartDate)} ~ ${this.$util.getDDMMYYYYDateFormat(item.effectiveEndDate)}`
                }
                return {
                    ...item,
                    effectiveDates,
                    displayMessage: preferedMessage?.title ?? defaultMessage?.title
                }
            }
        })
    ],

    data () {
        return {
            headers: [
                {
                    text: this.$t('ibeaconMessage.table.header.id'),
                    value: 'id',
                    width: '100px',
                    sortable: false
                },
                {
                    text: this.$t('ibeaconMessage.table.header.title'),
                    value: 'displayMessage',
                    sortable: false
                },
                {
                    text: this.$t('ibeaconMessage.table.header.effectiveDates'),
                    value: 'effectiveDates',
                    width: '220px'
                },
                {
                    text: '',
                    value: 'action',
                    width: '60px',
                    sortable: false
                }
            ]
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
